import { render } from "./MenuGroup.vue?vue&type=template&id=71a66bfe"
import script from "./MenuGroup.vue?vue&type=script&lang=js"
export * from "./MenuGroup.vue?vue&type=script&lang=js"

import "./MenuGroup.vue?vue&type=style&index=0&id=71a66bfe&lang=scss"
script.render = render

export default script